{
  "version": 1,
  "asset_id": "52d5ad10-eb80-42c2-bc74-2975199d15c1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/52d5ad10-eb80-42c2-bc74-2975199d15c1/revision-hub-annotated-1600.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/52d5ad10-eb80-42c2-bc74-2975199d15c1/revision-hub-annotated-1600.webp",
  "original_filename": "revision-hub-annotated-1600.webp",
  "size": 97966,
  "content_type": "image/webp",
  "created_at": "2026-10-05T21:16:53Z"
}
